import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

import { LabelValue } from "../../components/LabelValue";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductDifficultRatingMetaDataProps = {
    fitnessLevel?: string;
    difficultyLevel?: string;
    walkingDistance?: string;
};

export function ProductDifficultRatingMetaData({
    fitnessLevel,
    difficultyLevel,
    walkingDistance,
}: ProductDifficultRatingMetaDataProps) {
    const value = [difficultyLevel, fitnessLevel, walkingDistance].filter((item) => item).join(", ");

    const [t] = useProductTranslation();
    const label = t("label.difficultyLevel");

    return (
        <LabelValue label={label} Icon={FitnessCenterIcon}>
            {value}
        </LabelValue>
    );
}
